import { render, staticRenderFns } from "./logisticsCompany.vue?vue&type=template&id=0f570c6e&scoped=true&"
import script from "./logisticsCompany.vue?vue&type=script&lang=js&"
export * from "./logisticsCompany.vue?vue&type=script&lang=js&"
import style0 from "./logisticsCompany.vue?vue&type=style&index=0&id=0f570c6e&lang=scss&scoped=true&"
import style1 from "./logisticsCompany.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f570c6e",
  null
  
)

component.options.__file = "logisticsCompany.vue"
export default component.exports